(() => {
  'use strict';
  if (typeof window.NiralaWishlist?.init === 'function') { window.NiralaWishlist.init(); return; }
  const widget = document.querySelector('[data-wishlist-widget]');
  const customer = widget?.dataset.wishlistCustomer || '';
  const shop = widget?.dataset.wishlistShop || '';
  let identityRevoked = false;
  const authenticated = () => Boolean(!identityRevoked && widget?.isConnected && document.querySelector('[data-wishlist-widget]') === widget && widget.dataset.wishlistAuthenticated === 'true' && widget.dataset.wishlistCustomer === customer && widget.dataset.wishlistShop === shop);
  const hideGuestControls = () => {
    document.querySelectorAll('[data-wishlist-widget], [data-wishlist-open], [data-wishlist-toggle]').forEach(node => { node.hidden = true; });
    document.querySelectorAll('[data-wishlist-dialog][open]').forEach(node => node.close?.());
    return false;
  };
  if (!/^\d{1,20}$/.test(customer) || !/^[a-z0-9][a-z0-9.-]{0,254}$/i.test(shop) || !authenticated()) {
    hideGuestControls();
    window.NiralaWishlist = Object.freeze({ init: hideGuestControls, open: hideGuestControls });
    return;
  }
  // Deliberately do not read/migrate the legacy anonymous/shared wishlist key.
  const key = `nirala-favourites-v2:${encodeURIComponent(shop)}:${customer}`;
  const maximum = 100;
  let items = [];
  let storageFailed = false;
  let warned = false;
  let opener = null;
  const dialog = widget?.querySelector('[data-wishlist-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const list = dialog.querySelector('[data-wishlist-list]');
  const title = dialog.querySelector('[data-wishlist-title]');
  const label = title.textContent.trim() || 'Favourites';
  const tidy = value => typeof value === 'string' ? value.replace(/[\u0000-\u001f]/g, ' ').trim() : '';

  function productURL(value) {
    if (!tidy(value)) return '';
    try {
      const url = new URL(tidy(value), window.location.href);
      if (url.origin !== window.location.origin || url.username || url.password || !/^(?:\/[a-z]{2}(?:-[a-z0-9]+)*)?\/products\/[^/]+\/?$/i.test(url.pathname)) return '';
      return url.pathname;
    } catch (_) { return ''; }
  }
  function imageURL(value) {
    if (!tidy(value)) return '';
    try {
      const url = new URL(tidy(value), window.location.href);
      if (url.username || url.password) return '';
      const sameOrigin = url.origin === window.location.origin;
      const shopifyImage = ['cdn.shopify.com', 'cdn.shopifycdn.net'].includes(url.hostname);
      return (sameOrigin && ['http:', 'https:'].includes(url.protocol)) || (shopifyImage && url.protocol === 'https:') ? url.href : '';
    } catch (_) { return ''; }
  }
  function record(value) {
    if (!value || typeof value !== 'object') return null;
    const id = String(value.id || '');
    const url = productURL(value.url);
    const name = tidy(value.title).slice(0, 180);
    if (!/^\d{1,20}$/.test(id) || !url || !name) return null;
    return { id, url, title: name, image: imageURL(value.image) };
  }
  function parse(raw) {
    try {
      if (typeof raw !== 'string' || !raw || raw.length > 200000) return [];
      const values = JSON.parse(raw);
      if (!Array.isArray(values)) return [];
      const seen = new Set();
      return values.slice(0, maximum).map(record).filter(value => {
        if (!value || seen.has(value.id)) return false;
        seen.add(value.id); return true;
      });
    } catch (_) { return []; }
  }
  try { items = parse(window.localStorage.getItem(key)); }
  catch (_) { storageFailed = true; }

  function tell(message) {
    const status = dialog.querySelector('[data-wishlist-status]');
    status.textContent = message;
    status.hidden = !message;
    window.Nirala?.tell?.(message);
  }
  function persist() {
    if (!authenticated()) { revoke(); return; }
    if (!storageFailed) {
      try { window.localStorage.setItem(key, JSON.stringify(items)); }
      catch (_) { storageFailed = true; }
    }
    if (storageFailed && !warned) {
      warned = true;
      tell('Your browser could not save favourites permanently. They will remain available on this page.');
    }
  }
  function makeRow(item) {
    const row = document.createElement('li');
    row.className = 'np-wishlist-item';
    const link = document.createElement('a');
    link.className = 'np-wishlist-item__link';
    link.href = item.url;
    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      image.width = 72; image.height = 72; image.loading = 'lazy';
      image.addEventListener('error', () => image.remove(), { once: true });
      link.append(image);
    }
    const name = document.createElement('span');
    name.textContent = item.title;
    link.append(name);
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'np-wishlist-remove';
    remove.dataset.wishlistRemove = item.id;
    remove.textContent = 'Remove';
    remove.setAttribute('aria-label', `Remove ${item.title} from favourites`);
    row.append(link, remove);
    return row;
  }
  function revoke() {
    identityRevoked = true;
    items = [];
    list.replaceChildren();
    widget.querySelectorAll('[data-wishlist-count]').forEach(node => { node.textContent = '0'; });
    return hideGuestControls();
  }
  function sync() {
    if (!authenticated()) return revoke();
    const saved = new Set(items.map(item => item.id));
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const item = record({ id: button.dataset.wishlistId, url: button.dataset.wishlistUrl, title: button.dataset.wishlistTitle, image: button.dataset.wishlistImage });
      button.hidden = !item;
      if (!item) return;
      const selected = saved.has(item.id);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${selected ? 'Remove' : 'Save'} ${item.title} ${selected ? 'from' : 'to'} favourites`);
      button.title = selected ? 'Remove from favourites' : 'Save to favourites';
    });
    widget.querySelectorAll('[data-wishlist-count]').forEach(node => { node.textContent = String(items.length); });
    const launcher = widget.querySelector('[data-wishlist-open]');
    launcher.hidden = false;
    launcher.setAttribute('aria-label', `${label}, ${items.length} saved`);
    list.replaceChildren(...items.map(makeRow));
    dialog.querySelector('[data-wishlist-empty]').hidden = items.length > 0;
  }
  function remove(id, restoreFocus = false) {
    if (!authenticated()) return revoke();
    items = items.filter(item => item.id !== id);
    persist(); sync();
    if (restoreFocus) {
      const next = list.querySelector('[data-wishlist-remove]') || title;
      next.focus({ preventScroll: true });
    }
  }
  function open(trigger) {
    if (!authenticated()) return revoke();
    // Preserve existing delivery/product/cart dialog flows; never stack over them.
    if (document.querySelector('dialog[open]')) return;
    opener = trigger;
    sync();
    dialog.showModal();
    title.focus({ preventScroll: true });
  }
  document.addEventListener('click', event => {
    if (!authenticated()) { revoke(); return; }
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      const item = record({ id: toggle.dataset.wishlistId, url: toggle.dataset.wishlistUrl, title: toggle.dataset.wishlistTitle, image: toggle.dataset.wishlistImage });
      if (!item) return;
      if (items.some(saved => saved.id === item.id)) { remove(item.id); return; }
      if (items.length >= maximum) { tell('You can save up to 100 favourites. Remove one to add another.'); return; }
      items.unshift(item);
      persist(); sync();
      return;
    }
    const launcher = event.target.closest('[data-wishlist-open]');
    if (launcher) { event.preventDefault(); open(launcher); return; }
    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton && dialog.contains(removeButton)) { remove(removeButton.dataset.wishlistRemove, true); return; }
    if (event.target.closest('[data-wishlist-close]')) dialog.close();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus({ preventScroll: true }); opener = null; });
  window.addEventListener('storage', event => {
    if (!authenticated()) { revoke(); return; }
    if (storageFailed || (event.key !== key && event.key !== null)) return;
    items = parse(event.newValue);
    sync();
  });
  // A browser back/forward cache restore can otherwise show an earlier account's
  // signed-in HTML after logout. Require fresh server-rendered customer context.
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    revoke();
    window.location.reload();
  });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('nirala:cart-updated', sync);
  window.NiralaWishlist = { init: sync, open: () => open(widget.querySelector('[data-wishlist-open]')) };
  sync();
})();
